import { createReducer, on } from '@ngrx/store';
import {
  loadBudgets,
  loadBudgetsFailure,
  loadBudgetsSuccess,
  submitProject, submitProjectFailure,
  submitProjectSuccess
} from '../actions/civic-budget.actions';
import { CivicBudgetListItem } from '../../services/civic-budget.common.model';

export interface CivicBudgetState {
  budgets: CivicBudgetListItem[];
  loading: number;
  pending: number;
}

export const civicBudgetInitialState: CivicBudgetState = {
  budgets: [],
  loading: 0,
  pending: 0
};

export const civicBudgetReducer = createReducer(
  civicBudgetInitialState,
  on(loadBudgets, state => ({ ...state, loading: state.loading + 1 })),
  on(loadBudgetsSuccess, (state, action) => ({ ...state, loading: state.loading - 1, budgets: action.budgets })),
  on(loadBudgetsFailure, state => ({ ...state, loading: state.loading - 1 })),

  on(submitProject, (state, action) => ({ ...state, pending: state.pending + 1 })),
  on(submitProjectSuccess, (state, action) => ({ ...state, pending: state.pending - 1 })),
  on(submitProjectFailure, (state, action) => ({ ...state, pending: state.pending - 1 }))
);
